import { rootStore } from '@/models'
import { getSegmentClient } from '@/models/analytics/segment'
import { getLoginLifecycleProps, shouldAliasToAuth0 } from '@/models/analytics/analytics-identity'
import { Platform } from 'react-native'
import { warmOtherPlatformsOncePerSession } from '../../utils/thirdPartyUtils/silentSignInWarmer'

export function onSignInSuccess() {
  if (!rootStore) {
    throw new Error('Root store is not initialized')
  }
  const store = rootStore
  const user = store.session.user
  if (Platform.OS === 'web') {
    warmOtherPlatformsOncePerSession('app')
  }
  if (!user) {
    throw new Error('User is not logged in')
  }

  // IMPORTANT: Order matters!
  // 1. Alias Auth0 ID (links the previous Segment ID, e.g. legacy Mongo ID → Auth0 ID)
  if (shouldAliasToAuth0(user.auth0Id, store.analytics.getSegmentUserID())) {
    getSegmentClient()?.alias(user.auth0Id)
  }

  // 2. Identify with traits (setUserIdentify maps the Mongo ID to the Auth0 ID)
  store.analytics.setUserIdentify(user._id, {
    email: store.session.userEmail || user.email || undefined,
    anonymousId: store.share.segmentAnonymousId !== '' ? store.share.segmentAnonymousId : undefined,
    auth0Id: user.auth0Id
  })

  const eventPayload = {
    email: user.email,
    userRoles: user.userRoles as string[],
    segmentUserId: store.analytics.getSegmentUserID(),
    segmentIdentity: store.analytics.getUserIdentify()
  }

  store.analytics.setEvent('Login Completed', {
    ...getLoginLifecycleProps(user, store.session.userInfo?.isUserNew),
    ...eventPayload
  })
}
